'use strict';
import PopoverManager from "../../js/components/popoverManager";

export default class HotelRatingSummary extends HTMLElement
{
    constructor()
    {
        super();

        this.stylesheet = this.getAttribute('stylesheet');
        this.summarySubtextIcon = this.getAttribute('summary-subtext-icon');
        this.smallRatingLabel = this.getAttribute('small-rating-label');
        this.hotelRatingSummary = JSON.parse(this.getAttribute('hotel-rating-summary'));
        this.popoverText = this.getAttribute('popover-text');
    }

    connectedCallback()
    {
        let shadow = this.attachShadow({mode: 'open'});
        const template = document.querySelector('#hotel-rating-summary');
        const instance = template.content.cloneNode(true);

        if (this.stylesheet !== null) {
            instance.querySelector('[name="stylesheet"]').addEventListener('load', () => {
                this.style.display = '';
            });
            instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

            if(this.summarySubtextIcon){
                this._createSummarySubtextIcon(instance.querySelector('[name="summary-subtext-icon"]'));
            }

            let ratingSection = instance.querySelector('.rating-section');
            if (this.hotelRatingSummary && this.hotelRatingSummary.ratingText <= 0) {
                ratingSection.style.display = 'none';
            } else {
                let ratingLabel = instance.querySelector('.rating-label');
                this._setRatingLabelSize(ratingLabel);
            }

            if (this.popoverText) {
                const popoverTemplate = document.querySelector('#hotel-rating-summary-popover');
                const instanceTemplate = popoverTemplate.content.cloneNode(true);
                let hotelRatingInfoPopoverContentView = instanceTemplate.querySelector('[name="hotel-rating-info-popover-content"]');
                let hotelRatingInfoPopoverWrapperView = instanceTemplate.querySelector('[name="hotel-rating-info-popover-wrapper"]');
                let popoverIcon = document.createElement('i');
                popoverIcon.classList.add('ci', 'ci-info-circle', 'ci-s-15', 'ml-1', 'flex', 'mt-1', 'mb-1');
                hotelRatingInfoPopoverWrapperView.appendChild(popoverIcon);
                hotelRatingInfoPopoverContentView.innerHTML = this.popoverText;
                hotelRatingInfoPopoverWrapperView.classList.add('popover-wrapper', 'popover-secondary-darker', 'popover-right');
                let summaryText = instance.querySelector('[name="summary-text"]');
                summaryText.appendChild(instanceTemplate);
            }

            shadow.appendChild(instance);
            new PopoverManager(shadow);
            return shadow;
        }
    }

    _createSummarySubtextIcon(summarySubtextIconInstance)
    {
        summarySubtextIconInstance.innerHTML = `<i class="${this.summarySubtextIcon}"></i>`;
    }

    _setRatingLabelSize(ratingLabelInstance)
    {
        if (this.smallRatingLabel === 'true')
        {
            ratingLabelInstance.classList.add('sm');
        }
    }
}
